import { Dispatch } from 'redux';
import { LOAD_SETTINGS, AppDispatchTypes } from './types';

export const loadSettings = (googleKey: string) => async (dispatch: Dispatch<AppDispatchTypes>) => {
  dispatch({type: LOAD_SETTINGS, payload: googleKey});
}